import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { AuthService } from '../../../shared/services/auth.service';
import { ApiCallsService } from '../../../shared/services/network/api-calls.service';
import { passwordMatching } from '../../../shared/validators/custom.validator';
import { SafeHtmlPipe } from '../../../shared/validators/safe-html.pipe';
import { EMAIL_REGEX, MOBILE_REGEX, PASSWORD_REGEX } from '../../../utils/constants';
import { ICONS } from '../../../utils/svg-icons';

@Component({
  selector: 'app-sign-up-profile',
  templateUrl: './sign-up-profile.component.html',
  styleUrl: './sign-up-profile.component.scss',
  imports: [ReactiveFormsModule, CommonModule, RouterLink, SafeHtmlPipe],
})
export class SignUpProfileComponent {
  showError: boolean = false;
  isPasswordVisible: boolean = false;
  isConfirmationPasswordVisible: boolean = false;
  setupAccountForm!: FormGroup;
  isLoading: boolean = false;
  ICONS = ICONS;

  constructor(
    private _auth: AuthService,
    private _formBuilder: FormBuilder,
    private _activatedRoute: ActivatedRoute,
    private _apiService: ApiCallsService,
  ) {}

  ngOnInit(): void {
    this._initializeSetupAccountForm();
    const token = this._activatedRoute.snapshot.paramMap.get('token') ?? '';
  }

  private _initializeSetupAccountForm(): void {
    this.setupAccountForm = this._formBuilder.group(
      {
        email: ['', [Validators.required, Validators.pattern(EMAIL_REGEX)]],
        phoneNumber: ['', [Validators.required, Validators.pattern(MOBILE_REGEX)]],
        countryCode: ['+1'],
        password: ['', Validators.compose([Validators.required, Validators.maxLength(16), Validators.pattern(PASSWORD_REGEX)])],
        confirmPassword: ['', Validators.compose([Validators.required, Validators.maxLength(16)])],
        deviceToken: ['deviceToken'],
        tos: [true],
        userType: ['user'],
        accept: [, [Validators.required]],
        accept_msg: [, [Validators.required]],
      },
      {
        validator: [passwordMatching('password', 'confirmPassword')],
      },
    );
  }

  onSetupAccount(): void {
    if (this.setupAccountForm.valid && this.setupAccountForm.value.accept != false && this.setupAccountForm.value.accept_msg != false) {
      this.isLoading = true;
      // this.setupAccountForm.patchValue({
      //   phoneNumber: this.setupAccountForm.value.countryCode + this.setupAccountForm.value.phoneNumber
      // })
      let data = this.setupAccountForm.value;
      // data.phoneNumber=this.setupAccountForm.value.countryCode + this.setupAccountForm.value.phoneNumber
      delete data.countryCode;
      delete data.confirmPassword;
      delete data.accept;
      delete data.accept_msg;
      this._auth.setupAccount(data).catch((res: any) => {
        this.isLoading = false;
      });
    } else {
      if (this.setupAccountForm.value.accept_msg != true) {
        this._apiService?.errorAlert('You must agree to receive SMS messages for account security.', false, '', 'error');
      }
      this.showValidationMessage();
    }
  }

  private showValidationMessage(): void {
    const validationMessageDuration = 5000;
    this.showError = true;
    setTimeout(() => (this.showError = false), validationMessageDuration);
  }
}
